import { useWaitForDOMElement } from "@circle-react/hooks/useWaitForDOMElement";
import { Portal } from "@circle-react-uikit/Portal";
import type { PortalProps } from "@circle-react-uikit/Portal";

export interface AsyncPortalProps extends PortalProps {
  selectorQuery: string;
  timeoutMilliseconds?: number;
}

export const AsyncPortal = ({
  selectorQuery,
  timeoutMilliseconds,
  children,
  ...passthroughProps
}: AsyncPortalProps) => {
  const element = useWaitForDOMElement(selectorQuery, timeoutMilliseconds);
  if (!element) {
    return null;
  }

  return (
    <Portal element={element} {...passthroughProps}>
      {children}
    </Portal>
  );
};
